import Store from '@app/store';
import helpers from '@app/global/helpers';
import config from '@app/global/config';
export default {
    install(app) {
        // Install global variables
        app.config.globalProperties.$settings = config;
        app.config.globalProperties.$user = window.FRONTEND_USER;
        app.config.globalProperties.$pageTransitionDuration = 1000;
        app.config.globalProperties.$store = Store;
        app.config.globalProperties.$helpers = helpers;
        app.config.globalProperties.$image = helpers.image;
        app.config.globalProperties.__ = helpers.trans;
    },
};
